<template>
  <div class="forgot-password fullWidth">
    <div class="card">
      <div class="card-body">
        <div>
          <vue-form
            ref="form"
            :options="{
              permalink: 'forgotPasswordEmail'
            }">
          </vue-form>
        </div>
        <br/>
        <router-link :to="{ path : '/' }" class="btn btn-warning btn-sm"><i class="fa fa-arrow-left"></i> Back to Login </router-link>
        <hr/>
        <p>If you have any questions, just give us a call at
          <a href="tel:1800767266">1800 767 266</a> or you can email
          <a href="mailto:info@roscon.com" class="email">
            info@roscon.com</a>. We're always happy to help!</p>
      </div>
    </div>
  </div>
</template>

<script>
import VueForm from '@/components/Form.vue'

export default {
  name: 'ForgotPassword',
  components: {
    VueForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue